import { GalleryImage, MediaContentDTO } from 'models'
import { isNull } from 'utilities'
import { ImageIndications } from './ImageEditable.types'

export const getImageIndications = (
  image: MediaContentDTO | GalleryImage
): ImageIndications => {
  const {
    portrait, portraitWidth, portraitX, portraitY,
    square, squareWidth, squareX, squareY
  } = image

  const portraitCrop = !isNull(portraitWidth) && !isNull(portraitX) && !isNull(portraitY)
  const squareCrop = !isNull(squareWidth) && !isNull(squareX) && !isNull(squareY)

  return {
    portraitCrop,
    portraitForGeneralUse: !!portrait,
    squareCrop,
    squareForGeneralUse: !!square
  }
}
